<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>兑换记录</b>
        <div class="tips">
          <span
            >共 <i class="uc-blue">{{ list.total_count }}</i> 条记录</span
          >
        </div>
      </div>
      <div class="search">
        <input
          type="text"
          placeholder="请输入搜索关键字"
          class="uc-input"
          v-model="query.keyword"
        />
        <a href="javascript:;" @click="initData" class="uc-btn blue"
          ><i class="uc-font uc-search"></i
        ></a>
      </div>
    </div>

    <section class="uc-userCenterTitleTab4">
      <table>
        <tr>
          <th style="width:50%;">兑换单详情</th>
          <th style="width:15%;">数量</th>
          <th style="width:20%;">兑换时间</th>
          <th style="width:15%;">状态</th>
        </tr>
        <tr v-if="list.total_count == 0">
          <td colspan="10" class="empty-td">
            <div class="content-empty">
              <div class="emptyimg-box"></div>
              <p>暂无相关内容</p>
            </div>
          </td>
        </tr>

        <tr v-for="(item, index) in list.items" :key="index">
          <td>
            <div class="con">
              <div class="img img-box">
                <router-link to=""
                  ><el-image :src="item.img_url">
                    <div slot="error" class="image-slot">
                      <img src="../../assets/images/default-sp.png" />
                    </div> </el-image
                ></router-link>
              </div>
              <div class="r">
                <div class="txt">
                  订单号：<i class="uc-black">{{ item.order_number }}</i>
                </div>
                <h3>{{ item.product_name }}</h3>
                <div class="txt uc-pt5">
                  消耗积分：<i class="uc-blue">{{ item.consume_score }}分</i>
                </div>
                <div class="txt">
                  {{ item.product_description }}
                </div>
              </div>
            </div>
          </td>
          <td>x{{ item.consume_count }}</td>
          <td>{{ item.create_time }}</td>
          <td>
            {{ item.order_status_name }}
            <el-popover
              v-show="item.order_status > 0"
              placement="top-start"
              title=""
              width="300"
              trigger="hover"
            >
              <p>收件人：{{ item.user_name }}</p>
              <p class="uc-pt10">地址：{{ item.user_address }}</p>
              <p class="uc-pt10">手机号码：{{ item.user_phone }}</p>
              <p class="uc-pt10">
                {{ item.express_name }}：{{ item.express_number }}
              </p>
              <span slot="reference" class="el-icon-question"></span>
            </el-popover>

            <a
              href="javascript:;"
              @click="handleSubmitSure(item.id)"
              v-show="item.order_status === 1"
            >
              <div class="txt uc-pt10">
                <h3>
                  确认收货
                </h3>
              </div>
            </a>
          </td>
        </tr>
      </table>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'PorsonalOrder',
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: 10,
        keyword: undefined,
      },
      list: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getIntegralOrders();
    },
    async getIntegralOrders() {
      const response = await this.$api.integral.getIntegralOrders(this.query);
      this.list = response.data.data;
    },
    // 提交数据
    handleSubmitSure(orderId) {
      this.$confirm('确认收到此商品吗?', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.sureOrder(orderId);
        })
        .catch(() => {
          this.$message.info('已取消');
        });
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
    // 确认收货
    async sureOrder(orderId) {
      const response = await this.$api.integral.sureOrder({ id: orderId });
      if (response.data.code === 200) {
        this.initData();
      } else {
        this.$message.warning(response.data.message);
      }
    },
  },
};
</script>
